<template>
  <v-container fluid>
    <v-card class="referee">
      <v-card-title class="d-flex justify-space-between">
        <v-btn color="error" text @click="$router.back()">
          <v-icon class="mx-2"> arrow_back </v-icon>
          back
        </v-btn>
        <v-card-text>
          <div class="">
            <p class="">Referees</p>
          </div>
          <v-form v-model="isValid" ref="refereeForm">
            <v-row>
              <v-col cols="12" md="4" sm="12" xs="12">
                <v-text-field
                  v-model="formData.name"
                  placeholder="Enter referee's name"
                  label="Name"
                  :rules="rules.required"
                  dense
                  persistent-placeholder
                  color="primary"
                  outlined
                  prepend-inner-icon="person"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="4" sm="12" xs="12">
                <v-text-field
                  v-model="formData.phoneNo"
                  placeholder="Enter referee's  Number"
                  label="Phone Number"
                  :rules="rules.phoneNo"
                  dense
                  color="primary"
                  persistent-placeholder
                  outlined
                  prepend-inner-icon="phone"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="4" sm="12" xs="12">
                <v-text-field
                  v-model="formData.eMail"
                  placeholder="Enter referee's  Email"
                  label="Email Address"
                  :rules="rules.eMail"
                  persistent-placeholder
                  dense
                  color="primary"
                  outlined
                  prepend-inner-icon="mail"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4" sm="12" xs="12">
                <v-text-field
                  v-model="formData.address"
                  placeholder="Enter referee's  address"
                  label="Address"
                  :rules="rules.required"
                  persistent-placeholder
                  dense
                  color="primary"
                  outlined
                  prepend-inner-icon="house"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="4" sm="12" xs="12">
                <v-text-field
                  v-model="formData.placeOfWork"
                  placeholder="Enter referee's  place Of Work"
                  label="place Of Work"
                  :rules="rules.required"
                  persistent-placeholder
                  dense
                  color="primary"
                  outlined
                  prepend-inner-icon="house"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="4" sm="12" xs="12">
                <v-text-field
                  v-model="formData.designation"
                  placeholder="Enter referee's  designation"
                  label="Designation"
                  :rules="rules.required"
                  persistent-placeholder
                  dense
                  color="primary"
                  outlined
                  prepend-inner-icon="work"
                  clearable
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card-title>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="submitReferee"
          class="white--text academic--button mr-4 my-3"
          color="primary"
        >
          <v-icon class="mx-3">{{
            $route.query.edit !== undefined ? "edit" : "save"
          }}</v-icon>
          {{ $route.query.edit !== undefined ? "Save" : "Submit" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import AuthService from "../../../dashboard/modules/auth/AuthService";
export default {
  name: "RefereeCard",
  data: function () {
    return {
      isValid: false,
      formData: {
        name: "",
        phoneNo: "",
        eMail: "",
        address: "",
        placeOfWork: "",
        designation: "",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.query.edit !== undefined) {
        v.$store.dispatch("Profile/getreferee", {
          lineNo: to.query.edit.toString(),
        });
      }
    });
  },
  computed: {
    referee() {
      return this.$store.getters["Profile/refereeGetters"]("referee");
    },
    rules() {
      return {
        required: [(v) => !!v || "field is required"],
        phoneNo: [
          (v) => !!v || "Phone number is required",
          (v) =>
            /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) ||
            "Invalid phone number format",
        ],
        eMail: [
          (v) => !!v || "E-mail is required",
          (v) =>
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v,
            ) || "E-mail must be valid",
        ],
      };
    },
  },
  watch: {
    referee() {
      this.formData = { ...this.referee };
    },
  },
  methods: {
    submitReferee() {
      if (!this.isValid) {
        this.$refs.refereeForm.validate();
      } else {
        this.formData.profileID = AuthService.user.profile_id;
        this.$route.query.edit !== undefined
          ? this.$store.dispatch("Profile/editreferee", { ...this.formData })
          : this.$store.dispatch("Profile/submitreferee", {
              ...this.formData,
            });
      }
    },
  },
};
</script>
